module.exports = __webpack_public_path__ + "img/my girls the cutest.f303a110.png";